import type { APIApplicationFile } from 'types/api.types';
import { useApplicationFiles } from 'views/shared/hooks/useApplicationFiles';

export const useAppealFiles = (
  uuid: string,
  isOpen: boolean,
  initialFiles?: APIApplicationFile[],
) => {
  const {
    files,
    isUploadingFile,
    deletingFileId,
    handleFilesUpload,
    handleFileRemove,
    resetFiles,
  } = useApplicationFiles(uuid, 'appeal', { isOpen, initialFiles });

  return {
    supportingFiles: files,
    isUploadingFile,
    deletingFileId,
    handleFilesUpload,
    handleFileRemove,
    resetFiles,
  };
};
